export interface AlgorithmSettings {
  crossABOBarrier: string;
  crossHLABarrier: string;
  maxCycleLength: string;
  maxChainLength: string;
  maxAgeDifferenceRegular: string;
  maxAgeDifferenceVolunteer: string;
  maxAgeDifferenceAltruist: string;
  maxAgeDifferenceWaitingList: string;
  maxHLAMismatchRegular: string;
  maxHLAMismatchVolunteer: string;
  maxHLAMismatchAltruist: string;
  maxHLAMismatchWaitingList: string;
  maxDesensTransplantsPerRun: string;
  maxXABOTransplantsPerRun: string;
  maxXHLATransplantsPerRun: string;
  maxXABOandXHLATransplantsPerRun: string;
  allocationPointsPerVPRA: string;
  allocationPointsPerWaitlistYear: string;
  allocationPointsHLAMismatchInitialValue: string;
  allocationPointsHLAMismatchSubtractPerMismatch: string;
}

export interface SettingFieldConfig {
  key: keyof AlgorithmSettings;
  label: string;
  type: 'boolean' | 'integer' | 'decimal';
  min?: number;
  max?: number;
  step?: number;
}

export const ALGORITHM_SETTING_CONFIGS: SettingFieldConfig[] = [
  {
    key: 'crossABOBarrier',
    label: 'Allow ABOi transplants',
    type: 'boolean'
  },
  {
    key: 'crossHLABarrier',
    label: 'Allow HLAi transplants',
    type: 'boolean'
  },
  {
    key: 'maxCycleLength',
    label: 'Maximum length of cycle',
    type: 'integer',
    min: 0,
    max: 4
  },
  {
    key: 'maxChainLength',
    label: 'Maximum length of chain',
    type: 'integer',
    min: 0,
    max: 4
  },
  {
    key: 'maxAgeDifferenceRegular',
    label: 'Maximum allowed age difference for regular donor/patient pairs',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxAgeDifferenceVolunteer',
    label: 'Maximum allowed age difference for volunteer donor/patient pairs',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxAgeDifferenceAltruist',
    label: 'Maximum allowed age difference for altruistic donors',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxAgeDifferenceWaitingList',
    label: 'Maximum allowed age difference for patients on waiting list',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxHLAMismatchRegular',
    label: 'Maximum allowed HLA mismatch for regular donor/patient pairs',
    type: 'integer',
    min: 0,
    max: 6
  },
  {
    key: 'maxHLAMismatchVolunteer',
    label: 'Maximum allowed HLA mismatch for volunteer donor/patient pairs',
    type: 'integer',
    min: 0,
    max: 6
  },
  {
    key: 'maxHLAMismatchAltruist',
    label: 'Maximum allowed HLA mismatch for altruistic donors',
    type: 'integer',
    min: 0,
    max: 6
  },
  {
    key: 'maxHLAMismatchWaitingList',
    label: 'Maximum allowed HLA mismatch for patients on waiting list',
    type: 'integer',
    min: 0,
    max: 6
  },
  {
    key: 'maxDesensTransplantsPerRun',
    label: 'Maximum desensitization transplants per run',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxXABOTransplantsPerRun',
    label: 'Maximum cross-ABO transplants per run',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxXHLATransplantsPerRun',
    label: 'Maximum cross-HLA transplants per run',
    type: 'integer',
    min: 0
  },
  {
    key: 'maxXABOandXHLATransplantsPerRun',
    label: 'Maximum cross-ABO and cross-HLA transplants per run',
    type: 'integer',
    min: 0
  },
  {
    key: 'allocationPointsPerVPRA',
    label: 'Allocation points per %vPRA',
    type: 'decimal',
    min: 0,
    step: 0.1
  },
  {
    key: 'allocationPointsPerWaitlistYear',
    label: 'Allocation points per waitlist year',
    type: 'decimal',
    min: 0,
    step: 0.1
  },
  {
    key: 'allocationPointsHLAMismatchInitialValue',
    label: 'Initial value for HLA mismatches allocation points',
    type: 'integer',
    min: 0
  },
  {
    key: 'allocationPointsHLAMismatchSubtractPerMismatch',
    label: 'Amount of allocation points to subtract per HLA mismatch',
    type: 'integer',
    min: 0
  }
];